import React from 'react';
import { StatusLabel } from '@sierralabs/core-ui';
import styled from 'styled-components';
import { FormTemplateStatus } from '../FormTemplate.interface';
const StyledStatusLabelContainer = styled.div `
  display: flex;
  white-space: nowrap;
  .status-label {
    margin-right: 8px;
  }
`;
export function getPublishedStatusLabel(status) {
    switch (status) {
        case 'draft':
            return 'Draft';
        case 'published':
            return 'Published';
    }
}
export const PublishStatusLabels = ({ status, version }) => {
    const statusLabel = getPublishedStatusLabel(status);
    return (React.createElement(StyledStatusLabelContainer, { className: 'status-label-container' },
        version > 1 && (React.createElement(StatusLabel, { status: `Published v${version - 1}`, className: FormTemplateStatus.Published })),
        status !== FormTemplateStatus.Published && (React.createElement(StatusLabel, { status: `${statusLabel} v${version}`, className: status }))));
};
export default PublishStatusLabels;
//# sourceMappingURL=PublishStatusLabels.js.map